import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { DevExtremeModule } from 'devextreme-angular';
import { AppInformationService, CdrUnitOfWork, SessionInformationService, UtilityService } from 'src/app/core/core.module';
import { DialogService } from 'src/app/shared/shared.module';
import { EmailDialogComponent } from 'src/app/shared/email-dialog/email-dialog.component';

@Component({
    selector: 'app-invoice-communications',
    standalone: true,
    templateUrl: './invoice-communications.component.html',
    styleUrls: ['./invoice-communications.component.scss'],
    imports: [DevExtremeModule, RouterLink]
})
export class InvoiceCommunicationsComponent implements OnInit {
    communications: any[];
    filter: { type: string; customer: string; invoiceNumber: string; createdFrom: Date; createdTo: Date };
    typeOptions = ['Print', 'Email'];
    isLimited = false;
    defaultTake = 1000;

    constructor(
        private uow: CdrUnitOfWork,
        private sessionInfo: SessionInformationService,
        private appInfo: AppInformationService,
        private dialogService: DialogService
    ) {}

    async ngOnInit() {
        this.filter = this.sessionInfo.getItem('invoice-communications-filter', true) ?? {
            type: null,
            customer: null,
            invoiceNumber: null,
            createdFrom: null,
            createdTo: null
        };
        await this.search();
    }

    async search() {
        const hasFilter = Object.values(this.filter).some(value => !!value);
        this.isLimited = !hasFilter;
        await this.getData(hasFilter ? null : this.defaultTake);
        this.sessionInfo.setItem('invoice-communications-filter', this.filter, true);
    }

    clear() {
        this.filter = { type: null, customer: null, invoiceNumber: null, createdFrom: null, createdTo: null };
        this.search();
    }

    async getData(take?: number) {
        this.appInfo.pleaseWaitShow();
        this.communications = await this.uow.getInvoiceCommunications(this.filter, take);
        this.communications.forEach(communication => {
            communication.created = UtilityService.utcToLocal(communication.created);
            communication.sent = UtilityService.utcToLocal(communication.sent);
        });
        this.appInfo.pleaseWaitHide();
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons'
            },
            {
                template: 'toolbarText',
                location: 'after'
            },
            {
                location: 'after',
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    }
                }
            },
            {
                location: 'after',
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    }
                }
            }
        );
    }

    onRowDoubleClick(e) {
        if (!e.data) return;
        if (e.data.type === 'Email' && e.data.emailMessageId) this.viewEmail(e.data.emailMessageId);
    }

    async viewEmail(emailMessageId: number) {
        const dialogRef = this.dialogService.open(EmailDialogComponent);
        dialogRef.instance.emailMessageId = emailMessageId;

        await dialogRef.instance.show();
        this.dialogService.close(dialogRef);
    }
}
